import dayjs from 'dayjs';
import {
    updateForm as updateFormForTransaction,
} from "../../../Transaction/initTransaction/helper/updateForm";

const Date = date => (date ? dayjs(date) : undefined);

// Helper Function
function getInitFormData(transaction, frequency) {
    return {
        name: transaction.name,
        transaction_type: transaction.transaction_type,
        transaction_status: transaction.transaction_status,
        frequency,
        every: transaction.every,
        day: transaction.day,
        month: transaction.month,
        date_from: Date(transaction.date_from),
        date_to: Date(transaction.date_to),
        send_email: transaction.send_email,
        post_dating: transaction.post_dating,
        batch_processing: transaction.batch_processing,

        // PanelEmail for invoices and bills
        cc_email_addresses: transaction.cc_email_addresses || undefined,
        reply_to_email: transaction.reply_to_email || undefined,
        email_subject: transaction.email_subject,
        email_message: transaction.email_message,
        email_form_design_id: transaction.email_form_design_id,
        email_attach_pdf: transaction.email_attach_pdf,
    };
}

// Main Function
export function* updateForm(instruction, transaction, form) {
    const formData = getInitFormData(instruction);
    form?.setFieldsValue?.(formData);

    yield updateFormForTransaction(transaction, instruction.transaction_type, form);
}
